module.exports = __webpack_public_path__ + "img/sobuy.c8fb8ae2.png";